import { WeatherTooltip as FeWeatherTooltip } from '@fe/weather';
import { WeatherTooltipData } from '../../../services/map-interaction-service';

export function WeatherTooltip(props: { info: WeatherTooltipData }) {
    const context = props.info;

    return context.layers.map((layer, i) => (
        <div className="p-2" key={i} style={{ fontSize: 12, maxWidth: 400 }}>
            <div style={{ fontWeight: 'bold' }}>{layer.product.name}</div>
            <div className='d-flex flex-column gap-2'>
                {layer.objects.map((object, i) => (
                    <FeWeatherTooltip key={i} object={object} layer={layer} />
                ))}
            </div>
        </div>
    ));
}
